<template>
    <div
        class="dwv"
        :style="{
            maxWidth: width ? `${width}px` : undefined,
            maxHeight: height ? `${height}px` : undefined,
        }"
    >
        <div class="dwv-header">
            <div class="dwv-header-title">
                {{ title }}
            </div>
            <button
                v-if="closeButton"
                class="dwv-header-close _button"
                @click="$emit('dwvClose')"
                :aria-label="$t('close')"
                v-tooltip="$t('close')"
            >
                <mg-icon icon="x" />
            </button>
        </div>
        <div
            class="dwv-body"
            :class="{
                padded,
            }"
        >
            <slot></slot>
        </div>
    </div>
</template>

<script setup lang="ts">
import { WindowProps } from "@/composables/modal";

defineProps<WindowProps>();

defineSlots<{
    header: (props: {}) => any;
}>();

defineEmits<{
    dwvClose: [];
}>();
</script>

<style scoped lang="scss">
.dwv {
    background-color: var(--panel);
    border-radius: var(--radius);
    display: flex;
    flex-direction: column;
    contain: paint;
    border: 1px solid var(--accentedBg);

    > .dwv-header {
        position: sticky;
        display: flex;
        top: 0;
        flex-shrink: 0;
        height: 45px;

        align-items: center;

        background: var(--windowHeader);
        backdrop-filter: var(--blur, blur(15px));
        border-bottom: 1px solid var(--accentedBg);

        > .dwv-header-title {
            padding: 0 16px;

            unicode-bidi: isolate;
            flex-grow: 1;
            align-content: center;
            pointer-events: none;

            font-weight: bold;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            min-width: 0;
        }

        > .dwv-header-close {
            padding: 8px 10px;
            border-radius: calc(var(--radius) / 2);
            margin-right: 8px;

            &:hover {
                background-color: var(--accentedBg);
            }
        }
    }

    > .dwv-body {
        contain: content;
        overflow: auto;
        flex-grow: 1;

        &.padded {
            padding: 16px;
        }
    }
}
</style>
